<div class="card p-0" [style.background-color]="cardColor">
  <div class="containertest-container row m-0" *ngIf="isCardOpen">
    <div class="col-8 p-0 bder-right">
      <div class=" bder-bottom row m-0 py-3">
        <div class="containertest col-4">
          <div class="content_count">
            <span class="material-symbols-outlined title_logo">
              group
            </span>
            <div>Resources</div>
            <div class="count_Value">20</div>
          </div>
        </div>
        <div class="containertest col-4">
          <div class="content_count">
            <div class="title_logo_img">
              <img src="../../../../assets/images/cloud/sme.png" width="100%" height="100%">
            </div>
            <div>SME</div>
            <div class="count_Value">20</div>
          </div>
        </div>
        <div class="containertest col-4">
          <div class="content_count">
            <span class="material-symbols-outlined title_logo">
              workspace_premium
            </span>
            <div>Certifications</div>
            <div class="count_Value">20</div>
          </div>
        </div>
      </div>
      <div class="row m-0 py-3">

        <div class="paternship_map map_list col-4">
          <div class="content_count">
            <span class="material-symbols-outlined title_logo">
              partner_exchange
            </span>
            <div>Paternships</div>
          </div>
          <div class="domains_container">
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">4</div>
                <div>AWS</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/AWS.png" width="100%" height="100%" title="AWS" alt="AWS">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">2</div>
                <div>GCP</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/GCP.png" width="100%" height="100%" title="GCP" alt="GCP">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">6</div>
                <div>MDI</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/MICROSOFT.png" width="100%" height="100%"
                  title="Microsoft digital Innovation" alt="Microsoft digital Innovation ">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">2</div>
                <div>MDAI</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/mircosoft2.png" width="100%" height="100%"
                  title="Microsoft Data AI Azure" alt="Microsoft AI Azure">
              </div>
            </div>
          </div>

        </div>
        <div class="domain_map map_list col-8">
          <div class="content_count">
            <div class="title_logo_img">
              <img src="../../../../assets/images/cloud/domian.png" width="100%" height="100%">
            </div>
            <div>Verticals</div>
          </div>
          <div class="domains_container">
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count"> 5</div>
                <div>BFS</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/Banking.jpg" width="100%" height="100%"
                  title="Banking" alt="Banking">

              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">7</div>
                <div>C&M</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/communication.png" width="100%" height="100%"
                  title="C&M" alt="C&M">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">3</div>
                <div>Hi-Tech</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/download (3).jpg" width="100%" height="100%"
                  title="Hi-Tech" alt="Hi-Tech">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">8</div>
                <div>HIL</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/healthcare.jpg" width="100%" height="100%"
                  title="HIL" alt="HIL">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">4</div>
                <div>Misc</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/manufacturing.jpg" width="100%" height="100%"
                  title="Misc" alt="Misc">
              </div>
            </div>
            <div class="verticals_content">
              <div class="verticals_content_header">
                <div class="vertical_count">5</div>
                <div>REMTT</div>
              </div>
              <div class="Paternships_logo">
                <img src="../../../../assets/images/cloud/icons/icons/publci sector.png" width="100%" height="100%"
                  title="REMTT " alt="REMTT">
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="col-4 p-1">
      <div class="org_image h-100">
        <img src="../../../../assets/images/cloud/org_chart.png" width="100%" height="100%" alt="Org_chart"
          title="Org_chart">
      </div>
    </div>
  </div>
</div>